import { useContext, useEffect } from 'react';
import {
  Breadcrumb,
  BreadcrumbsContext
} from '../../context/BreadcrumbsContext';

export function useConfigureBreadcrumbs(breadcrumbs: Array<Breadcrumb>): void {
  const { setBreadcrumbs } = useContext(BreadcrumbsContext);
  useEffect(() => {
    setBreadcrumbs(breadcrumbs);
  }, [setBreadcrumbs, breadcrumbs]);
}
